import React, { useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import { API_BASE_URL } from '../config/api';
import { getLoggedInUserData } from '../services/authService';
import { getDecryptedData } from '../utils/authStorage';
import PageShell from './ui/PageShell';

function Profile() {
  const localStoreEmail = getDecryptedData('Email');
  const [loginUserData, setloginUserData] = useState([]);

  useEffect(() => {
    const loadUser = async () => {
      if (!localStoreEmail) return;
      try {
        const users = await getLoggedInUserData(localStoreEmail);
        setloginUserData(users);
      } catch (error) {
        console.error('Failed to fetch user data:', error);
        setloginUserData([]);
      }
    };
    loadUser();
  }, [localStoreEmail]);

  return (
    <PageShell
      title="My Profile"
      subtitle="Employee details, contact information, and account status."
      breadcrumbs={[
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Profile' },
      ]}
      backTo="/dashboard"
    >
      <div className="hr-profile-grid">
        {loginUserData.map((item) => (
          <Card key={item._id} className="hr-profile-card">
            <Card.Img variant="top" src={`${API_BASE_URL}/${item.ProfilePic}`} className="hr-profile-card-img" />
            <Card.Body>
              <Card.Title>{item.EmployeeName}</Card.Title>
              <Card.Subtitle className="text-muted">{item.UserType}</Card.Subtitle>
            </Card.Body>
            <ListGroup className="list-group-flush">
              <ListGroup.Item>Employee Code: {item.EmpCode}</ListGroup.Item>
              <ListGroup.Item>Email: {item.Email}</ListGroup.Item>
              <ListGroup.Item>Status: {item.Status}</ListGroup.Item>
            </ListGroup>
            <Card.Body>
              <Button variant="primary" className="hr-btn-primary" disabled>
                Edit Profile
              </Button>
            </Card.Body>
          </Card>
        ))}
      </div>
    </PageShell>
  );
}

export default Profile;
